module.exports = __webpack_public_path__ + "static/media/icon-note-pinned.c208d1cd.svg";